import React from 'react'

const TopMessaging = () => {
  return (
    <div className="bg-gray-900 border-b border-gray-800">
      <div className="container mx-auto px-4 py-2 text-gray-400 text-xs sm:text-sm text-center prose">Trading is risky, and most day traders lose money. Read our <a href="#footer-disclaimer">full disclaimer</a>.</div>
    </div>
  )
}

export default TopMessaging